import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Here I am!", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "And here's a joke for you", -1)

import {onBeforeMount, onBeforeUnmount, onMounted, onUnmounted, ref} from "vue";
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const joke = ref('joke');
const getData = async() => {
  console.log("[CHILD COMPONENT] getData() triggered");
  axios
    .get('https://api.chucknorris.io/jokes/random')
    .then(response => {
      console.log("[CHILD COMPONENT] response from server called by [getData()]",response);
      joke.value = response.data.value
    });
};

onBeforeMount(() => {
  console.log("[CHILD COMPONENT] onBeforeMount call [getData()]")
  getData();
});

onMounted(() => {
    console.log("[CHILD COMPONENT] mounted!");
});

onBeforeUnmount (() => {
  console.log("[CHILD COMPONENT] beforeUnmounted!");
});

onUnmounted(() => {
  console.log("[CHILD COMPONENT] unmounted!");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("p", null, _toDisplayString(joke.value), 1),
    _createElementVNode("pre", null, _toDisplayString(joke.value), 1)
  ]))
}
}

})